export default __webpack_public_path__ + "static/media/Pistol_7.e6061b32.png";